const theme = {
	ltr: "ltr",
	rtl: "rtl",
	placeholder: "editor-placeholder",
	paragraph: "editor-paragraph",
	link: "editor-link",
};

export default theme;
